import { render, staticRenderFns } from "./SchemaFieldPanel.vue?vue&type=template&id=22b9c842&scoped=true&"
import script from "./SchemaFieldPanel.vue?vue&type=script&lang=js&"
export * from "./SchemaFieldPanel.vue?vue&type=script&lang=js&"
import style0 from "./SchemaFieldPanel.vue?vue&type=style&index=0&id=22b9c842&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b9c842",
  null
  
)

export default component.exports